// extracted by mini-css-extract-plugin
export default {"card":"DayCard_card__uN1DC","day":"DayCard_day__rJAcu","content":"DayCard_content__8QiIM"};